import { collectionEngineV1 } from '../../apis.js';
import { APIBASE } from '../../config.js';
import { authToken, selectedOwnerIds } from '../../internal.js';
const apcoaAPI = collectionEngineV1('/apcoa');
export const getFeeImages = (feeId) => apcoaAPI('GET', `/fee/${feeId}/images`);
export const getFeeImagesStream = (feeId) => {
    return fetch(`${APIBASE}/collection-engine/v1/${selectedOwnerIds[0]}/apcoa/fee/${feeId}/images`, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
            'X-Debbie-Auth-Token': authToken,
        },
    }).then((x) => {
        if (x.status >= 400) {
            throw new Error('Error fetching fee images');
        }
        return x.body;
    });
};
export const getFee = (feeId) => apcoaAPI('GET', `/fee/${feeId}`);
export const getDMR = (feeId, registrationNumber) => apcoaAPI('GET', `/dmr/${feeId}?registrationNumber=${registrationNumber}`);
export const getParkingLot = (parkingLotCode) => apcoaAPI('GET', `/parkinglot/${parkingLotCode}`);
export const getParkingLotFiles = (parkingLotCode) => apcoaAPI('GET', `/parkinglot/${parkingLotCode}/files`);
export const getParkingLotFile = (parkingLotCode, path) => apcoaAPI('GET', `/parkinglot/${parkingLotCode}/files/${path}`);
export const patchParkingLot = (parkingLotCode, patch) => apcoaAPI('PATCH', `/parkinglot/${parkingLotCode}`, {
    body: patch,
});
export const getNavZip = (caseSeqId) => apcoaAPI('GET', `/nav-zip/${caseSeqId}`);
//# sourceMappingURL=apcoa.js.map